import { render, staticRenderFns } from "./IntegralConfig.vue?vue&type=template&id=2ea335f2&scoped=true"
import script from "./IntegralConfig.vue?vue&type=script&lang=js"
export * from "./IntegralConfig.vue?vue&type=script&lang=js"
import style0 from "./IntegralConfig.vue?vue&type=style&index=0&id=2ea335f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea335f2",
  null
  
)

export default component.exports